export default __webpack_public_path__ + "static/media/verify_mail.70791f9b.png";